import { Component, OnDestroy, OnInit } from '@angular/core'
import { Subject } from 'rxjs'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { ISearchUser } from '../../../modules/general/users/core/interfaces/ISearchUser'
import { ISearchUserResponse } from '../../../modules/general/users/core/interfaces/ISearchUserResponse'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { UserService } from '../../../modules/general/users/core/services/user.service'
import { ToastrService } from 'ngx-toastr'
import { takeUntil } from 'rxjs/operators'
import { SendPushInterface } from '../../../modules/general/users/core/interfaces/send-push.interface'
import { HttpErrorResponse } from '@angular/common/http'

@Component({
	selector: 'app-send-push-modal',
	templateUrl: './send-push-modal.component.html',
})
export class SendPushModalComponent implements OnInit, OnDestroy {
	private _unSubscribeAll: Subject<any> = new Subject<any>()

	public form: FormGroup

	public foundUsers: ISearchUser[] = []
	public isLoadingUsers: boolean = false

	public isSendToAll: boolean = true
	public isLoadingSendPush: boolean = false

	constructor(
		private _activeModal: NgbActiveModal,
		private _formBuilder: FormBuilder,
		private _userService: UserService,
		private _toastrService: ToastrService,
	) {}

	private _initForm() {
		this.form = this._formBuilder.group({
			title: this._formBuilder.group({
				ru: [null, Validators.required],
				en: [null, Validators.required],
			}),
			body: this._formBuilder.group({
				ru: [null, Validators.required],
				en: [null, Validators.required],
			}),
			path: ['', Validators.required],
			action: [''],
			users: [[]],
		})
	}

	public searchUsers(event: any) {
		const { value } = event.target
		this.isLoadingUsers = true
		this._userService
			.searchUsers(value)
			.pipe(takeUntil(this._unSubscribeAll))
			.subscribe(
				(response: ISearchUserResponse) => {
					this.foundUsers = response.results
					this.isLoadingUsers = false
				},
				(error) => {
					this.isLoadingUsers = false
					this._toastrService.error(error?.error?.error?.message || 'Не удалось найти пользователя')
				},
			)
	}

	public closeModal() {
		this._activeModal.close()
	}

	public sendPush() {
		const formValue: SendPushInterface = this.form.value

		this.isLoadingSendPush = true
		this._userService
			.sendPush(formValue)
			.pipe(takeUntil(this._unSubscribeAll))
			.subscribe(
				(response: any) => {
					this.isLoadingSendPush = false
					this.closeModal()
					this._toastrService.success('Уведомление успешно отправлено')
				},
				(error: HttpErrorResponse) => {
					this.isLoadingSendPush = false
					this._toastrService.error(error?.error?.error?.message || 'Не удалось отправить уведомление')
				},
			)
	}

	public onChangeUsers() {
		this.isSendToAll = !this.form.get('users')?.value?.length
	}

	public onChangeSendToAll() {
		this.form.patchValue({ users: [] })
	}

	public customSearch(term: string, item: ISearchUser): boolean {
		if (!term) return true
		term = term.toLowerCase()

		const inFullName: boolean = item.full_name?.toLowerCase().includes(term)
		const inEmail: boolean = item.email?.toLowerCase().includes(term)
		const inExtended: boolean = item.extended_label?.toLowerCase().includes(term)

		return inFullName || inEmail || inExtended
	}

	ngOnInit() {
		this._initForm()
	}

	ngOnDestroy() {
		this._unSubscribeAll.next(null)
		this._unSubscribeAll.complete()
	}
}
